// extracted by mini-css-extract-plugin
module.exports = {"root":"c3O5j-b","disabled":"gzfZ1j","icon":"beyupp"};